var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFeat2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#58F2A9",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 24C5 15.0433 5 10.565 7.78248 7.78248C10.565 5 15.0433 5 24 5C32.9566 5 37.435 5 40.2176 7.78248C43 10.565 43 15.0433 43 24C43 32.9566 43 37.435 40.2176 40.2176C37.435 43 32.9566 43 24 43C15.0433 43 10.565 43 7.78248 40.2176C5 37.435 5 32.9566 5 24Z",
    stroke: "#141B34",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 16.0771L23.9985 27.3577M23.9985 27.3577C24.5202 27.3646 25.0349 27.0061 25.4147 26.5683L27.9579 23.7161M23.9985 27.3577C23.4952 27.351 22.9854 26.9943 22.5823 26.5683L20.0243 23.7161M17.5726 32.0771L30.3726 32.0771",
    stroke: "#1ED760",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat2);
export default __webpack_public_path__ + "static/media/feat2.15198a32134594c9098c452b8546756f.svg";
export { ForwardRef as ReactComponent };